export const INVENTORY_ROUTE_NAMES = {
    LIST: "InventoryList",
    CARD: "InventoryCard",
    ADD: "InventoryAdd",
    EDIT: "InventoryEdit",
    COPY: "InventoryCopy",
};
